import { EmbeddingTextData } from "@/API";
import { Button, Group, Modal, Textarea } from "@mantine/core";
import { useForm } from "@mantine/form";
import { useDisclosure } from "@mantine/hooks";
import { PropsWithChildren, useEffect } from "react";

export function EmbeddingTextDataEditButton(props: { defaultData?: EmbeddingTextData, onChange?: (data: EmbeddingTextData) => void, title?: string } & PropsWithChildren) {
    const [opened, { open, close }] = useDisclosure(false);
    const form = useForm<EmbeddingTextData>({
        initialValues: props.defaultData,
        validate: {
        }
    });
    useEffect(() => {
        if (opened) {
            if (props.defaultData) form.setValues(props.defaultData)
            else form.reset()
        }
    }, [opened])

    return <>
        <div onClick={open}>
            {props.children}
        </div>
        <Modal opened={opened} onClose={close} title={props.title} size="xl">
            <form onSubmit={form.onSubmit((values) => {
                props.onChange?.(values)
                close()
            })}>
                <Textarea
                    label="Text"
                    maxRows={10}
                    autosize
                    {...form.getInputProps('text')}
                />
                <Textarea
                    label="Template"
                    description="可以使用{{$text}}引用Text"
                    maxRows={10}
                    autosize
                    {...form.getInputProps('template')}
                />
                <Group justify="flex-end" mt="md">
                    <Button type="submit">確認</Button>
                </Group>
            </form>
        </Modal>
    </>
}